import * as API from '@/services/API';

export default {
  getImages({ commit }, payload) {
    commit('SET_LOADING', true, { root: true });
    API.apiClient
      .get('/galleries/' + payload.id)
      .then((response) => {
        commit('SET_IMAGES', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  addGallery({ commit }, payload) {
    API.apiClient.post('/galleries', payload);
    API.apiClient
      .get('/properties/' + payload.parent_id)
      .then((response) => {
        commit('properties/SET_CURRENT_PROPERTY', response.data, { root: true });
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  addImage({ commit, state }, payload) {
    return API.apiClient
      .post('/images', payload)
      .then((response) => {
        const images = JSON.parse(JSON.stringify(state.images));
        images.push(response.data);
        commit('SET_IMAGES', images);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  deleteImage({ commit, state }, payload) {
    API.apiClient
      .delete('/images/' + payload)
      .then((response) => {
        const images = JSON.parse(JSON.stringify(state.images));
        const filtered = images.filter(function (element, index, arr) {
          return element.id != payload;
        });
        commit('SET_IMAGES', filtered);
      })
      .catch((error) => [commit('SET_ERROR', error, { root: true })]);
  },

  updateImage({ commit, state, dispatch }, payload) {
    return API.apiClient.put('/images/' + payload.id, payload);
  },

  updateImageList({ commit, state, dispatch }, payload) {
    for (let index = 0; index < payload.length; index++) {
      payload[index].order = index;
      API.apiClient.put('/images/' + payload[index].id, payload[index]);
    }
    commit('SET_IMAGES', payload);
  },
};
